<!-- <p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [dismissableMask]="true" (onHide)="onClose()"
    [style]="{ width: '90vw', maxWidth: '500px', height: '98vh', maxHeight: '660px' }"> -->

<div class=" bg-gray-20 border-gray-300 ">

    <div class="bg-custom-blue w-[calc(100%+3rem)] -ml-6 px-6  pt-1  text-white rounded-t pb-2 sm:px-10">

        <h2 class=" text-2xl font-bold mt-4 font-mulish text-white">About Reserve Prices</h2>

        <p class="text-sm mt-2  font-mulish font-semibold  text-white">A reserve price is the minimum a seller will
            accept. If it’s not met, the item won’t be sold—even to the highest bidder. The amount is hidden, so bid
            higher to increase your chances of winning.</p>
    </div>
    <div class="flex flex-col md:flex-row w-full gap-4  ">
        <div class=" flex-1 rounded-lg bg-white shadow-md text-center mt-4 pb-2">

            <div class="flex justify-center items-center gap-2 w-full ">
                <fa-icon [icon]="faLock " class="text-orange-600 text-base font-bold"></fa-icon>
                <h2 class=" text-lg font-bold  font-mulish ">Reserve Not Met</h2>
            </div>


            <div class="space-y-2 px-2 mt-2">
                <div class="flex  items-center gap-2 w-full">
                    <fa-icon [icon]="faChevronRight" class="text-[10px] font-bold"></fa-icon>

                    <p class="font-mulish text-sm text-left">
                        You may be leading the auction, but the item won’t be sold to you unless the reserve is met.
                    </p>
                </div>

                <div class="flex  items-center gap-2 w-full">
                    <fa-icon [icon]="faChevronRight" class="text-[10px] font-bold"></fa-icon>

                    <p class="font-mulish text-sm text-left">
                        You’ll see a message like “Reserve Not Met” even if you’re the top bidder.
                    </p>
                </div>

                <div class="flex  items-center gap-2 w-full">
                    <fa-icon [icon]="faChevronRight" class="text-[10px] font-bold"></fa-icon>

                    <p class="font-mulish text-sm text-left">
                        You’ll need to place a higher bid to meet the reserve and secure the item.
                    </p>
                </div>
            </div>
        </div>

        <div class="flex-1 rounded-lg bg-white shadow-md  mt-4 px-2 ">
            <div class="flex justify-center items-center gap-2 w-full ">
                <fa-icon [icon]="faSquareCheck " class="text-base text-custom-blue font-bold"></fa-icon>
                <h2 class=" text-lg font-bold  font-mulish ">Reserve Met</h2>
            </div>




            <div class="space-y-2 px-2 mt-2">
                <div class="flex  items-center gap-2 w-full">
                    <fa-icon [icon]="faChevronRight" class="text-[10px] font-bold"></fa-icon>

                    <p class="font-mulish text-sm text-left">
                        The “Reserve Met” status will be shown.
                    </p>
                </div>

                <div class="flex  items-center gap-2 w-full">
                    <fa-icon [icon]="faChevronRight" class="text-[10px] font-bold"></fa-icon>

                    <p class="font-mulish text-sm text-left">
                        If no higher bids are placed, you’ll win the item when the auction ends.
                    </p>
                </div>

            </div>
        </div>

    </div>

    <div class="flex-1 rounded-lg bg-white shadow-md  mt-4 px-2 pb-4 ">
        <div class="flex items-center gap-2 w-full mt-6">
            <fa-icon [icon]="faEye" class="text-base text-custom-blue font-bold"></fa-icon>

            <p class="font-mulish text-lg font-bold">
                Why Don’t We Show the Reserve Price?
            </p>
        </div>
        <p class="font-mulish text-sm">To keep the auction competitive, the exact reserve amount is kept
            private. If you’re serious about
            winning, consider increasing your maximum bid to ensure you meet the reserve.</p>
    </div>

    <div class="px-4">
        <button pButton class=" h-[40px] p-button-info rounded-m w-full relative flex items-center justify-center mt-6 "
            (click)=onClose() [rounded]="true">
            <fa-icon [icon]="faCheckCircle" class="text-white text-base font-bold p-0 m-0 left-3"></fa-icon>
            <span class="font-semibold text-white text-center w-full text-base">
                Done
            </span>
        </button>
    </div>
</div>
<!-- </p-dialog> -->